export default "__VITE_ASSET__4e39d3b5__"